import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';

const hostname = window.location.hostname;
const pathname = window.location.pathname;

const isGrantonino =
  process.env.REACT_APP_PRODUCT === 'grantonino' ||
  hostname.includes('grantonino') ||
  pathname.startsWith('/g/');

const isRestaurantApp =
  process.env.REACT_APP_PRODUCT === 'restaurant-ai' ||
  hostname.startsWith('mesa') ||
  hostname.includes('checkflow-frontend-pr99') ||
  pathname.startsWith('/restaurant-ai');

const root = ReactDOM.createRoot(document.getElementById('root'));

if (isGrantonino) {
  import('./grantonino/GranotonApp').then(({ default: GranotonApp }) => {
    root.render(<React.StrictMode><GranotonApp /></React.StrictMode>);
  });
} else if (isRestaurantApp) {
  import('./restaurant-ai/RestaurantApp').then(({ default: RestaurantApp }) => {
    root.render(<React.StrictMode><RestaurantApp /></React.StrictMode>);
  });
} else {
  import('./App').then(({ default: App }) => {
    root.render(<React.StrictMode><App /></React.StrictMode>);
  });
}

reportWebVitals();
